module.exports = __webpack_public_path__ + "static/media/shouye1.317e3086.png";